module.exports = function (dispatch) {
  return {
    dispatchAction,
    dispatchActionWithValue,
    dispatchActionWithChecked,
    dispatchAuthRequiredAction,
    dispatchRolloutRequiredAction
  }

  function dispatchAction(action, argsMutator) {
    if (typeof argsMutator === 'function') {
      return function (...args) {
        dispatch(action(argsMutator(...args)))
      }
    }
    return function (...args) {
      dispatch(action(...args))
    }
  }

  function dispatchActionWithValue(action) {
    return dispatchAction(action, event => event.currentTarget.value)
  }

  function dispatchActionWithChecked(action) {
    return dispatchAction(action, event => event.currentTarget.checked)
  }

  function dispatchAuthRequiredAction(loggedInAction, loggedOutAction) {
    return function (...args) {
      dispatch(function (dispatch, getState) {
        const { user } = getState()
        if (user.loggedIn) {
          dispatch(loggedInAction(...args))
        } else {
          dispatch(loggedOutAction(...args))
        }
      })
    }
  }

  function dispatchRolloutRequiredAction(rolloutName, rolloutAction, fallbackAction) {
    return function (...args) {
      dispatch(function (dispatch, getState) {
        const { user } = getState()
        if (user.hasRollout(rolloutName)) {
          dispatch(rolloutAction(...args))
        } else if (fallbackAction) {
          dispatch(fallbackAction(...args))
        }
      })
    }
  }
}
